<!-- HEADER
<div class="header accent-700 p-24" fxLayout="column">
    <div fxLayoutAlign="space-between center">

        <h1>Aviso <span>{{ seconds }}s</span></h1>

        <div id="countdown">
            
        </div>

    </div>

</div>

<div id="info" class="p-24">
 -->
<!-- </div> -->

<!-- / HEADER -->

<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="header accent-700 p-24">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="contact-name mt-8">Aviso</div> <span>{{ seconds }}s</span>
            <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>  
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-12" fusePerfectScrollbar style="min-height: 300px;">

        <div id="info" class="p-24">

        </div>

    </div>
</div>